module.exports = __webpack_public_path__ + "img/failedupload.6bff9a0b.svg";